export default __webpack_public_path__ + "static/media/hht1_ep05_timeline_q02_b.9e71db3f.png";